import { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { findPathPages } from 'utils/pages';

import Tooltip from 'components/UI/Tooltip/Tooltip';

import { PAGE_PATH } from 'components/config/pages';

import { ReactComponent as CrownIcon } from 'images/Icons/Crown.svg';

import styles from './GameBar.module.scss';

const GameBar = ({
  type = 'vertical',
  gameName,
  gameCode,
  icon,
  percentage,
  backgroundColor,
  withTooltip = true,
  withCrown = true,
}) => {
  const contentJSX = useMemo(
    () => (
      <div
        className={styles.fill}
        style={{
          backgroundColor,
          ...(type === 'vertical'
            ? { height: `${percentage}%` }
            : { width: `${percentage}%` }),
        }}
      >
        <div className={styles.iconWrapper}>
          {withCrown && <CrownIcon className={styles.iconCrown} />}
          <img src={icon} alt="game_icon" className={styles.icon} />
        </div>
      </div>
    ),
    [backgroundColor, type, percentage, withCrown, icon],
  );

  return (
    <Link
      to={findPathPages(PAGE_PATH.GAME).replace(':gameCode', gameCode)}
      className={classNames(styles.root, styles[type])}
    >
      {withTooltip ? (
        <Tooltip
          title={gameName}
          typographyProps={{ type: 'text-md', weight: 'semibold' }}
        >
          {contentJSX}
        </Tooltip>
      ) : (
        contentJSX
      )}
    </Link>
  );
};

GameBar.propTypes = {
  type: PropTypes.oneOf(['horizontal', 'vertical']),
  gameName: PropTypes.string.isRequired,
  gameCode: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  backgroundColor: PropTypes.string,
  withTooltip: PropTypes.bool,
  withCrown: PropTypes.bool,
};

export default memo(GameBar);
